import React, { useState } from 'react';
import UI from '../../ui';
import useOnboardingState from './useOnboardingState';
import { countries, TCountryCode } from 'countries-list';
import HotelSearch from '../../components/HotelSearch';
import extractEntries from '../../helpers/extractKeys';

const Intro: React.FC<{ skip: () => void, addHotels: () => void }> = ({ skip, addHotels }) => {
  return (
    <UI.VerticalLayout gap={20}>
      <UI.VerticalLayout>
        <UI.Text size="title" weight="bold">Would you like to add the hotels you have stayed at now?</UI.Text>
        <UI.Text>Add as many as you can and select your favorite</UI.Text>
      </UI.VerticalLayout>
      <UI.VerticalLayout gap={5}>
        <UI.Button label="Add hotels now" onClick={addHotels} />
        <UI.Button label="Skip this step" onClick={skip} type="secondary" />
      </UI.VerticalLayout>
    </UI.VerticalLayout>
  );
};

type hotel = { name: string, id: string };
const CountryHotels: React.FC<{ country: TCountryCode, hotels: hotel[], setHotels: (v: hotel[]) => void }> = ({ country, hotels, setHotels }) => {
  return (
    <UI.VerticalLayout gap={5}>
      <HotelSearch
        country={country}
        onSelectedHotel={(hotel) => {
          const name = hotel.name;
          const id = hotel.place_id;
          if (name && id && !hotels.some(h => h.id === id)) {
            setHotels([...hotels, ({ id, name })]);
          }
        }}
      />
      {hotels.map((hotel, i) => (
        <UI.HorizontalLayout key={i} color="greige" padding="10px" justify="space-between" align="center">
          <UI.Text>{hotel.name}</UI.Text>
          <UI.IconButton name="close" onClick={() => setHotels(hotels.filter(({ id }) => id !== hotel.id))} />
        </UI.HorizontalLayout>
      ))}
    </UI.VerticalLayout>
  );
};

const AddHotels: React.FC = () => {
  const { countries: addedCountries } = useOnboardingState();
  const initialHotels = addedCountries.reduce((acc, curr) => ({ ...acc, [curr]: [] }), {} as Record<TCountryCode, hotel[]>);
  const [countriesHotels, setCountriesHotels] = useState<Record<TCountryCode, hotel[]>>(initialHotels);
  return (
    <UI.VerticalLayout width="100%" overflow="scroll">
      <UI.AccordionGroup
        items={extractEntries(countriesHotels).map(({ key, value }) => ({
          label: countries[key].name,
          endAdornment: <UI.Text color={value.length === 0 ? 'black' : 'chartreuse'}>{`${value.length} added`}</UI.Text>,
          content: <CountryHotels country={key} hotels={value} setHotels={hotels => setCountriesHotels(prev => ({ ...prev, [key]: hotels }))} />,
        }))}
      />
    </UI.VerticalLayout>
  );
};

const AddHotelsStep: React.FC<{ skip: () => void }> = ({ skip }) => {
  const [addingHotels, setAddingHotels] = useState(false);
  return (
    <React.Fragment>
      {addingHotels ? <AddHotels /> : <Intro skip={skip} addHotels={() => setAddingHotels(true)} />}
    </React.Fragment>
  );
};

export default AddHotelsStep;
